var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { Subject } from 'rxjs/internal/Subject';
var ConfigurePermissionComponent = /** @class */ (function (_super) {
    __extends(ConfigurePermissionComponent, _super);
    function ConfigurePermissionComponent(injector, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.bsModalRef = bsModalRef;
        _this.active = false;
        _this.saving = false;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(ConfigurePermissionComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    ConfigurePermissionComponent.prototype.close = function () {
        this.active = false;
        this.bsModalRef.hide();
        this._onClosed.next(this.allPermissions);
        this._onClosed.complete();
    };
    ConfigurePermissionComponent.prototype.refreshPermissionList = function (permissionList) {
        this.allPermissions = permissionList || [];
    };
    ConfigurePermissionComponent = __decorate([
        Component({
            selector: 'configure-permission',
            template: "<div class=\"modal-content fe-popup-large\" *ngIf=\"active\"> <div class=\"modal-header fe-popup-header\"> <div class=\"fe-popup-title\"> {{lc(\"PermissionManangement\")}} </div> <div class=\"fe-popup-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <configure-permission-list [configureId]=\"configureId\" (refreshPermissionList)=\"refreshPermissionList($event)\"></configure-permission-list> <div class=\"fe-popup-bottom\"> <div class=\"button-group\"> <button type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one float-right\" (click)=\"close()\">{{l(\"Close\")}}</button> </div> </div> </div> ",
            styles: ["#permissionModal{ z-index: 10000 !important; } "]
        })
    ], ConfigurePermissionComponent);
    return ConfigurePermissionComponent;
}(ConfigureComponentBase));
export { ConfigurePermissionComponent };
